import en from './en';
import cn from './cn';
export default {
    en: en,
    cn: cn
}


// WEBPACK FOOTER //
// ./src/utils/i18n/langs/index.js